import styled from '@emotion/styled/macro';
import Icon from '@mdi/react';
import { BaseButton, Variables } from '../../base';
import MarkdownWrapper from '../../base/markdown-wrapper/markdown-wrapper';

export const Card = styled.section`
    display: flex;
    flex-direction: column;
    width: 100%;
    margin-bottom: 24px;
    padding: 16px 20px;
    background: ${Variables.ThemeLight.PrimaryInverted11};
    border: 1px solid ${Variables.ThemeLight.PrimaryInverted7};
    border-radius: 12px;
    box-sizing: border-box;
`;

export const Header = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 12px;
`;

export const HeaderLeft = styled.div`
    display: flex;
    align-items: center;
    gap: 8px;
    min-width: 0;
`;

export const HeaderRight = styled.div`
    display: flex;
    align-items: center;
    gap: 4px;
    flex-shrink: 0;
`;

export const IconBadge = styled.div`
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 22px;
    height: 22px;
    border-radius: 6px;
    background-color: ${Variables.ThemeLight.PrimaryConstant6};
    color: ${Variables.Colors.white};
    flex-shrink: 0;
`;

export const TitleIcon = styled(Icon)`
    width: 14px;
    height: 14px;
    fill: currentColor;
`;

export const Title = styled.h2`
    margin: 0;
    font-family: ${Variables.Fonts.calibre};
    font-size: 12px;
    font-weight: 600;
    line-height: 1;
    letter-spacing: 0.07em;
    text-transform: uppercase;
    color: ${Variables.ThemeLight.PrimaryConstant6};
    white-space: nowrap;
`;

export const UpdatedAt = styled.span`
    font-size: 12px;
    font-weight: 400;
    line-height: 1.2;
    color: ${Variables.ThemeLight.TextXMild};
    white-space: nowrap;
`;

export const FollowUpButton = styled(BaseButton)`
    display: inline-flex;
    align-items: center;
    gap: 6px;
    padding: 4px 8px;
    min-height: auto;
    border: none;
    background: transparent;
    color: ${Variables.ThemeLight.PrimaryConstant6};
    font-size: 13px;
    font-weight: 500;
    line-height: 1.2;
    cursor: pointer;

    &:hover:not(:disabled) {
        background-color: ${Variables.ThemeLight.PrimaryMild2};
    }

    &:disabled {
        color: ${Variables.ThemeLight.TextXMild};
        cursor: not-allowed;
    }
`;

export const FollowUpIcon = styled(Icon)`
    width: 14px;
    height: 14px;
    fill: currentColor;
`;

export const CollapseButton = styled.button`
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 28px;
    height: 28px;
    padding: 0;
    border: none;
    border-radius: 6px;
    background: transparent;
    color: ${Variables.ThemeLight.TextMedium};
    cursor: pointer;

    &:hover {
        background-color: ${Variables.ThemeLight.NeutralMild1};
    }
`;

export const Body = styled.div`
    display: flex;
    flex-direction: column;
    gap: 12px;
    margin-top: 12px;
`;

export const SummaryText = styled(MarkdownWrapper)`
    margin: 0;
    font-size: 14px;
    font-weight: 400;
    line-height: 1.5;
    color: ${Variables.ThemeLight.TextStrong};

    p {
        margin: 0;
    }

    strong,
    b {
        font-weight: 600;
    }
`;

export const NextRow = styled.div`
    display: flex;
    align-items: baseline;
    flex-wrap: wrap;
    gap: 6px;
`;

export const NextLabel = styled.span`
    font-family: ${Variables.Fonts.calibre};
    font-size: 12px;
    font-weight: 600;
    line-height: 1.4;
    letter-spacing: 0.07em;
    text-transform: uppercase;
    color: ${Variables.ThemeLight.PrimaryConstant6};
    flex-shrink: 0;
`;

export const NextText = styled.span`
    font-size: 14px;
    font-weight: 400;
    line-height: 1.5;
    color: ${Variables.ThemeLight.TextStrong};
`;

export const LoadingRow = styled.div`
    display: flex;
    align-items: center;
    gap: 10px;
    margin-top: 12px;
    color: ${Variables.ThemeLight.TextMedium};
    font-size: 14px;
`;

export const ErrorText = styled.p`
    margin: 12px 0 0;
    font-size: 14px;
    line-height: 1.4;
    color: ${Variables.ThemeLight.AttentionConstant6};
`;
